module.exports = __webpack_public_path__ + "img/home-line2-img2.8d1305a7.png";